module.exports = __webpack_public_path__ + "img/works-09_ai-aoki.d09011ba.png";